import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { supplierService } from '../../services/supplierService';
import SupplierForm from '../../components/Suppliers/SupplierForm';
import Toast from '../../components/Common/Toast';

const EditEntity = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [entity, setEntity] = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  useEffect(() => {
    const loadEntity = async () => {
      try {
        const response = await supplierService.getSupplier(id);
        if (response.success && response.data) {
          setEntity({ ...response.data, id: Number(id) });
        } else {
          throw new Error('Entidad no encontrada');
        }
      } catch (error) {
        setToast({
          isOpen: true,
          message: error.response?.data?.message || 'Error al cargar la entidad',
          type: 'error',
        });
        setTimeout(() => navigate('/entities'), 1200);
      } finally {
        setLoading(false);
      }
    };
    if (id) loadEntity();
  }, [id, navigate]);

  if (loading) {
    return <div className="p-6 text-gray-500">Cargando...</div>;
  }

  if (!entity) return null;

  return (
    <div className="p-6">
      <div className="max-w-5xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Editar Entidad</h1>
          <p className="text-gray-600 mt-1">Modifique los datos de la entidad</p>
          <div className="mt-2 text-sm font-mono text-teal-600">Código: {entity.code}</div>
        </div>
        <SupplierForm
          isPageMode
          supplier={entity}
          showEntityTypes
          onSuccess={() => {
            setToast({ isOpen: true, message: 'Entidad actualizada exitosamente', type: 'success' });
            setTimeout(() => navigate('/entities'), 1200);
          }}
          onError={(error) =>
            setToast({
              isOpen: true,
              message: error.response?.data?.message || 'Error al actualizar la entidad',
              type: 'error',
            })
          }
        />
      </div>
      <Toast
        isOpen={toast.isOpen}
        message={toast.message}
        type={toast.type}
        onClose={() => setToast({ ...toast, isOpen: false })}
      />
    </div>
  );
};

export default EditEntity;

